export default __webpack_public_path__ + "static/media/flame.7d61ebb2.svg";